import type { Element } from "React";
type Props = {
  className?: string;
};

const IconSessionLogo = (props: Props): Element<"svg"> => (
  <svg
    width="55px"
    height="31px"
    viewBox="0 0 55 31"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsxlinkhref="http://www.w3.org/1999/xlink"
  >
    <desc>Created with Sketch.</desc>
    <defs>
      <polygon
        id="path-1"
        points="0 0.505148509 54.9539235 0.505148509 54.9539235 30.1614545 0 30.1614545"
      />
    </defs>
    <g
      id="08-Notifications"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="08-Notifications/08.02.01---Inactivity-modal"
        transform="translate(-133.000000, -208.000000)"
      >
        <g id="Group" transform="translate(20.000000, 184.000000)">
          <g
            id="3et-logo-reverse-copy-2"
            transform="translate(113.000000, 24.000000)"
          >
            <g id="Group-3" transform="translate(0.000000, 0.053620)">
              <mask id="mask-2" fill="white">
                <use xlinkHref="#path-1" />
              </mask>
              <g id="Clip-2" />
              <path
                d="M26.7074949,16.5845551 C26.9617296,15.1234001 27.5049949,13.9565987 28.3389745,13.0841507 C29.1718316,12.2139369 30.2667806,11.7777129 31.6221378,11.7777129 C32.9780561,11.7777129 34.065148,12.2206394 34.8845357,13.1053754 C35.7033622,13.99067 36.2118316,15.1513274 36.4099439,16.5845551 L26.7074949,16.5845551 Z M48.4987194,22.2269812 L48.4987194,12.5367761 L50.015148,12.5367761 L54.9539235,7.05465251 L48.4987194,7.05465251 L48.4987194,0.505148509 L42.0586684,0.505148509 L42.0586684,12.5367761 L42.0586684,14.4129303 C42.0463214,14.3710394 42.0362194,14.32859 42.0233112,14.2866991 C41.5855561,12.8099049 40.9075969,11.5029085 39.9899949,10.3645929 C39.0718316,9.22627724 37.920199,8.31975796 36.5367806,7.64503505 C35.152801,6.97031215 33.5145867,6.63350924 31.6221378,6.63350924 C29.955301,6.63350924 28.4371888,6.94294342 27.067801,7.56125324 C25.6972908,8.17956305 24.5181582,9.02296669 23.5298418,10.0909056 C22.5409643,11.1588445 21.7715255,12.4094278 21.2209643,13.8437725 C21.0683112,14.2414569 20.9386684,14.6458438 20.8281071,15.0574918 C19.7168827,13.370126 18.0966276,12.0508416 16.1811684,11.3292009 L21.4617296,5.33656669 L21.4617296,0.505148509 L18.8060153,0.505148509 L4.18611735,16.3052823 L12.6454541,16.3052823 C15.0031582,16.3052823 16.9214235,18.1831121 16.9214235,20.5479936 C16.9214235,22.9111994 15.0048418,24.7901463 12.6488214,24.7901463 L-5.61224489e-05,24.7901463 L-5.61224489e-05,30.0566714 L12.6488214,30.0566714 C16.7216276,30.0566714 20.2180561,27.6024227 21.6850969,24.0807936 C22.2322908,25.1437056 22.9231582,26.0904401 23.7633112,26.9142947 C24.8223418,27.9548649 26.0783622,28.7563776 27.5336173,29.3182743 C28.9883112,29.8807296 30.5631071,30.161678 32.2574439,30.161678 C34.3193827,30.161678 36.1130561,29.7891281 37.6384643,29.0445871 C39.1638724,28.300046 40.4625459,27.2667369 41.5361684,25.9452183 L37.8506071,22.6978351 C36.9459133,23.51387 36.0709643,24.1048111 35.2235153,24.4689827 C34.3760663,24.83483 33.4158112,25.0180329 32.3421888,25.0180329 C30.9020867,25.0180329 29.6943316,24.6454831 28.7200459,23.9003834 C27.7457602,23.1558423 27.1025969,22.0521565 26.7922398,20.5904431 L42.0586684,20.5904431 L42.0586684,23.2468852 C42.0586684,24.5684038 42.2208622,25.6570089 42.5458112,26.5138176 C42.870199,27.3717434 43.3225459,28.0682496 43.9017296,28.6016605 C44.480352,29.1361885 45.1723418,29.5081798 45.977699,29.71931 C46.7824949,29.9298816 47.6787704,30.0354467 48.6682092,30.0354467 C49.7412704,30.0354467 50.6869337,29.9148009 51.5068827,29.676302 C52.3257092,29.4383616 53.0743827,29.1216663 53.7523418,28.7278918 L53.7523418,23.5836881 C52.7629031,24.146702 51.7038724,24.4270918 50.5746888,24.4270918 C49.190148,24.4270918 48.4987194,23.6942801 48.4987194,22.2269812 Z"
                id="Fill-1"
                fill="#2B393F"
                mask="url(#mask-2)"
              />
            </g>
            <polygon
              id="Fill-4"
              fill="#4DA1A9"
              points="11.0033673 5.82507055 16.022398 0.558545455 0 0.558545455 0 5.82507055 4.29729592 5.82507055"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default IconSessionLogo;
